<template>
	<div>
		<template v-if="getMerchant().merchant_type == 'ticket'">
			<TicketCustom v-if="getMerchant().theme == 'ZOO'"></TicketCustom>
			<TicketDetailV2 v-else-if="getMerchant().is_special_merchant"></TicketDetailV2>
			<TicketMerchantDetail v-else></TicketMerchantDetail>
		</template>
		<RestaurantDetail v-if="getMerchant().merchant_type == 'restaurant'"></RestaurantDetail>
		<HotelDetailV2 v-if="getMerchant().merchant_type == 'hotel'"></HotelDetailV2>
		<!-- <template v-if="getMerchant().merchant_type == 'hotel'">
			<HotelDetailV2 v-if="$app_env == 'dev'"></HotelDetailV2>
			<HotelDetail v-else></HotelDetail>
		</template> -->
	</div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import TicketMerchantDetail from '@/pages/ticket/MerchantDetail'
  import TicketDetailV2 from '@/pages/ticket/TicketHomePage'
  import TicketCustom from '@/pages/ticket/custom/Home'
  import RestaurantDetail from "@/pages/restaurant/Home";
  import HotelDetail from '@/pages/hotel/HotelDetail'
  import HotelDetailV2 from '@/pages/hotel/HotelHomePage'

	export default{
		components:{
			TicketMerchantDetail,
			RestaurantDetail,
			HotelDetail,
			HotelDetailV2,
			TicketCustom,
			TicketDetailV2
		},
		data(){
			return{

			}
		},
		computed:{
			is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			}
		},
		methods:{
			...mapGetters(['getMerchant'])
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/Home.vue